module.exports = __webpack_public_path__ + "img/card.ebd9b5c8.png";